import { render, staticRenderFns } from "./GprEditor.vue?vue&type=template&id=4681e9dc&scoped=true"
import script from "./GprEditor.vue?vue&type=script&lang=js"
export * from "./GprEditor.vue?vue&type=script&lang=js"
import style0 from "./GprEditor.vue?vue&type=style&index=0&id=4681e9dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4681e9dc",
  null
  
)

export default component.exports